import ReactStars from "react-rating-stars-component";
import React, { useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Common_Title from "../../common/common-title/Common_Title";
import "./What_Student_Say.css";

const What_Student_Say = ({ feedback }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const decodeHTML = (html) => {
    if (typeof document === "undefined") return html;

    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  return (
    <section className="What_Student_Say">
      <div className="container">
        <Common_Title
          title="What Students & Parents "
          subtitle="Say About Us "
        />

        <div className="testimonial_swiper">
          <Swiper
            modules={[Pagination, Autoplay]}
            loop={feedback?.length > 3}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            centeredSlides={true}
            slidesPerView={3}
            spaceBetween={30}
            speed={800}
            pagination={{
              clickable: true,
            }}
            onSlideChange={(swiper) => {
              setActiveIndex(swiper.realIndex);
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              320: {
                slidesPerView: 1.2,
              },
              575: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 2,
              },
              992: {
                slidesPerView: 3,
              },
            }}
          >
            {feedback?.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="testimonial-card">
                  <div className="quote_wrapper">
                    <img
                      src={
                        index === activeIndex
                          ? "/assets/images/home/testimonials/blue-quote.png"
                          : "/assets/images/home/testimonials/pink-quote.png"
                      }
                      alt="quote"
                      className="quote-img"
                    />
                  </div>

                  <div className="testimonial-header">
                    <img
                      src={process.env.REACT_APP_IMG_URL + item?.image}
                      alt={item?.name}
                    />

                    <div>
                      <h5>{item?.name}</h5>
                      <span>{item?.location}</span>

                      <div className="stars">
                        <ReactStars
                          count={5}
                          value={item?.rating}
                          size={20}
                          isHalf={true}
                          edit={false}
                          activeColor="#ffd700"
                        />
                      </div>
                    </div>
                  </div>

                  <p className="testimonial-text">
                    {decodeHTML(
                      item?.description?.replace(/<\/?[^>]+(>|$)/g, "")
                    )}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default What_Student_Say;